module.exports = {
    RECEIVE_HYDROMETRIC_STATION: 'RECEIVE_HYDROMETRIC_STATION',
    RECEIVE_ALL_HYDROMETRIC_STATIONS: 'RECEIVE_ALL_HYDROMETRIC_STATIONS',
    RECEIVE_HYDROMETRY_THRESHOLDS: 'RECEIVE_HYDROMETRY_THRESHOLDS',

    // TODO : Move this list on other global constant file
    MONTHS: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
    ALL: 'ALL',
    MAX: 'MAX',
    MIN: 'MIN',
    SUM: 'SUM',
    AVERAGE: 'AVERAGE',
    HYDROMETER_HEIGHT_TYPE: 4,
    TIDE_GAUGE_TYPE: 4,

    // ---------------------
    WINDOW: 'window',
    POINT: 'point',
    MOVING: 'moving',
    NEWPOINT: 'newPoint',
    VALIDATION: 'validation',
    HISTORIC: 'historic',
    PURGE: 'purge',
    IMPORT: 'import',
    COMPENSATION: 'compensation',
    CORRECTION: 'correction',
    OPTIONS: 'options',
    THRESHOLDS: 'thresholds',
    EVENT: 'event',
    AUTO: 'auto',
    MANUAL: 'manual',
    RESET: 'reset',
    DELETE: 'delete',
    // ---------------------

    // ---------------------

    HYDRO_IMPORT_TYPE: {
        HYDRO_PORTAIL: 'HYDRO',
        EMPTY: 'EMPTY',
    },
    HYDRO_TYPEID: {
        SAMPLE: -2,
        HEIGHT: 4,
        FLOW: 5,
    },
    HYDRO_L_STORAGE: {
        DISPLAY_MODES_DASHBOARD: 'HYDRO_DISPLAY_MODES_DASHBOARD',
        STATUS_QUALIF_DASHBOARD: 'HYDRO_STATUS_QUALIF_DASHBOARD',
        DISPLAY_MODES_SUIVI: 'HYDRO_DISPLAY_MODES_SUIVI',
        STATUS_QUALIF_SUIVI: 'HYDRO_STATUS_QUALIF_SUIVI',
        TIME_VALIDATION: 'HYDRO_TIME_VALIDATION',
        TIME_OTHER_VALIDATION: 'HYDRO_TIME_OTHER_VALIDATION',
        TEMP_REF: 'HYDRO_TEMP_REF',
    },

    HYDRO_FOLLOW_L_STORAGE: {
        HIDDEN_THRESHOLDS_HYDROMETRIC_FOLLOW: 'HIDDEN_THRESHOLDS_HYDROMETRIC_FOLLOW',
        STAT_SERIES_HYDROMETRIC_FOLLOW: 'STAT_SERIES_HYDROMETRIC_FOLLOW',
        LINEAR_MODE_HYDROMETRIC_FOLLOW: 'LINEAR_MODE_HYDROMETRIC_FOLLOW',
        ACTIVE_YEARS_HYDROMETRIC_FOLLOW: 'ACTIVE_YEARS_HYDROMETRIC_FOLLOW',
        MODEL_CHECK_HYDROMETRIC_FOLLOW: 'MODEL_CHECK_HYDROMETRIC_FOLLOW',
        ASSOCIATED_STATIONS_HYDROMETRIC_FOLLOW: 'ASSOCIATED_STATIONS_HYDROMETRIC_FOLLOW',
        TYPE_ID_HYDROMETRIC_FOLLOW: 'TYPE_ID_HYDROMETRIC_FOLLOW',
        Y_ZOOM_HYDROMETRIC_FOLLOW: 'Y_ZOOM_HYDROMETRIC_FOLLOW',
        MODE_DATE: 'MODE_DATE',
    },

    HYDRO_MEASURE_COTE: {
        NGF: 1,
        HEIGHT: 2,
    },
    HYDRO_DISPLAY_COTE: 'HYDRO_DISPLAY_COTE',
    HYDRO_TAB_DISPLAY_MODES: 'HYDRO_TAB_DISPLAY_MODES',
}